import { BaseConditionData } from './base-condition-data';
import { WorkflowConditionTypes } from './Enums/workflow-condition-types';

/**
 * Représente les données d'une condition 'Les attributs obligatoire doivent être renseignés'.
 */
export class MandatoryAttributesMustBeFilledInConditionData extends BaseConditionData {
    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowConditionTypes.MandatoryAttributesMustBeFilledIn);
    }

    /**
     * Retourne une copie d'une instance de MandatoryAttributesMustBeFilledInConditionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: MandatoryAttributesMustBeFilledInConditionData) {
        if (!!other) {
            const instance = new MandatoryAttributesMustBeFilledInConditionData();
            instance.name = other.name;
            instance.type = other.type;
            instance.id = other.id;
            instance.isMainCondition = other.isMainCondition;

            return instance;
        } else {
            return null;
        }
    }
}
